<template>
  <div>
    <div class="d-flex justify-space-between align-center">
      Поле #{{ index + 1 }}
      <div>
        <v-btn
          :disabled="index === length - 1"
          icon
          @click="swapFields(index, index + 1)"
        >
          <v-icon>
            keyboard_arrow_down
          </v-icon>
        </v-btn>
        <v-btn
          :disabled="index === 0"
          icon
          @click="swapFields(index, index - 1)"
        >
          <v-icon>
            keyboard_arrow_up
          </v-icon>
        </v-btn>
        <v-btn
          icon
          @click="removeField(index)"
        >
          <v-icon
            small
            color="red"
          >
            clear
          </v-icon>
        </v-btn>
      </div>
    </div>
    <div>
      <v-select
        v-model="field.type"
        :items="fieldTypes"
        label="Тип поля"
        @input="handleInput($event, 'type')"
      />
      <v-text-field
        v-model="field.name"
        :rules="rules.fieldName"
        label="Название поля"
        hide-details
        @input="handleInput($event, 'name')"
      />
      <v-checkbox
        v-model="field.filterable"
        label="Участвует в фильтрации"
        class="mb-1"
        hide-details
        @change="handleInput($event, 'filterable')"
      />
      <v-checkbox
        v-model="field.public"
        label="Отображать поле в карточке геометрии"
        class="mb-1"
        hide-details
        @change="handleInput($event, 'public')"
      />
      <v-checkbox
        v-model="field.voronoiAvailable"
        label="Использовать для формирования диаграммы Вороного"
        class="mb-1"
        hide-details
        @change="handleInput($event, 'voronoiAvailable')"
      />
      <v-checkbox
        v-model="field.isTitle"
        label="Является заголовком"
        class="mb-1"
        hide-details
        @change="onTitleFieldChange($event, index)"
      />
      <div v-if="field.type === 'select'">
        <div class="d-flex align-center">
          Элементы списка
          <v-btn
            x-small
            icon
            class="ml-1"
            @click="addPreparedValue(index)"
          >
            <v-icon small color="green">add</v-icon>
          </v-btn>
        </div>
        <div
          v-if="!field.preparedValues.length"
          class="caption"
        >
          Нет элементов
        </div>
        <div
          v-for="(item, i) in field.preparedValues"
          :key="i"
          class="d-flex align-center"
        >
          <v-text-field
            :value="item"
            :rules="rules.itemName"
            :label="`Значение элемента ${i + 1}`"
            @input="updatepPeparedValues($event, 'preparedValues', i)"
          />
          <v-btn
            color="red"
            dark
            x-small
            @click="removePreparedValue(i)"
          >
            Удалить
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    field: {
      type: Object,
    },
    length: {
      type: Number,
    },
    rules: {
      type: Object,
      required: true,
    },
    fieldTypes: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleInput(value, prop) {
      this.$emit(
        'update',
        [value, prop],
      );
    },
    removeField(index) {
      this.$emit(
        'remove',
        index,
      );
    },
    swapFields(index, pos) {
      this.$emit(
        'swap',
        [index, pos],
      );
    },
    onTitleFieldChange($event, index) {
      this.$emit(
        'title-change',
        [$event, index],
      );
    },
    removePreparedValue(i) {
      this.$emit(
        'removeValue',
        i,
      );
    },
    addPreparedValue(index) {
      this.$emit(
        'pushValue',
        index,
      );
    },
    updatepPeparedValues(value, prop, i) {
      this.$emit(
        'updatePepared',
        [value, prop, i],
      );
    },
  },
};
</script>
